import React from 'react';

const DescriptionForMedia = ({ content, letters }) => {
    // 1️⃣ HTML tags remove karne ke liye
    const plainText = content.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ');

    // 2️⃣ words mein split karo aur count karo
    const words = plainText.trim().split(/\s+/).filter(word => word.length > 0);
    const wordLimit = 50;
    
    // 3️⃣ agar words 50 se zyada hain to pehle 50 words dikhao
    const shortText =
        words.length > wordLimit
            ? words.slice(0, wordLimit).join(' ') + '...'
            : plainText;

    return (
        <p className='m-0' style={{ fontSize: "13px" }}>{shortText}</p>
    );
};

export default DescriptionForMedia;
